import reset from 'styled-reset'
import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  ${reset}
  html {
    scroll-behavior: smooth;
  }
  body,
  main {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
  a {
    text-decoration: none;
  }
  button {
    outline: none;
  }
  img {
    width: 100%;
  }
`
